var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59326 12.63L2.7818 10.1394C1.08185 9.40802 0.646984 8.31095 1.47719 6.84821L2.0109 5.92905C2.8411 4.50584 3.99746 4.3477 5.47998 5.45465L10.5502 9.24988L9.80892 2.93437C9.59148 1.09606 10.313 0.176897 11.9734 0.176897H13.0408C14.7012 0.176897 15.4227 1.09606 15.2053 2.93437L14.464 9.24988L19.5342 5.45465C21.0365 4.32793 22.2027 4.49595 23.0329 5.9587L23.5666 6.87786C24.3969 8.32084 23.9521 9.40802 22.2324 10.1394L16.4209 12.63L22.262 15.1503C23.962 15.8817 24.3969 16.959 23.5666 18.3822L23.0329 19.3013C22.2027 20.7443 21.0464 20.9123 19.5639 19.8054L14.464 16.0101L15.2053 22.296C15.4227 24.1541 14.6913 25.0831 13.0111 25.0831H11.9734C10.313 25.0831 9.59148 24.1541 9.80892 22.296L10.5502 16.0101L5.47998 19.8054C3.9777 20.9321 2.81145 20.774 1.98125 19.331L1.44754 18.4118C0.597566 16.9688 1.04232 15.8718 2.7818 15.1206L8.59326 12.63Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconWhite);
export default __webpack_public_path__ + "static/media/star-icon-white.c68d322c859cc63fcfdf8f5097d91e4f.svg";
export { ForwardRef as ReactComponent };